var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonListBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.4541,
    width: 14.5455,
    height: 1.5,
    rx: 0.75,
    fill: "#2894FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    rx: 1,
    fill: "#2894FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.4541,
    y: 9,
    width: 14.5455,
    height: 1.5,
    rx: 0.75,
    fill: "#2894FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 8.7998,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#2894FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.4541,
    y: 18.3999,
    width: 14.5455,
    height: 1.5,
    rx: 0.75,
    fill: "#2894FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#2894FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonListBlue);
export default __webpack_public_path__ + "static/media/button_list-blue.cfeb9f41d681f90faa2eddd1e3c5f0bf.svg";
export { ForwardRef as ReactComponent };